import React from 'react'

// Top-level error boundary (review item §3.4). Previously a render error
// anywhere unmounted the whole app to a blank white page; now it shows a
// friendly recovery screen instead.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Hook a real error-reporting service in here when one is available.
    console.error('Uncaught render error:', error, info)
  }

  handleReload = () => {
    this.setState({ hasError: false })
    window.location.assign('/')
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#f0f4f3] flex items-center justify-center px-4">
          <div className="clay-card p-12 text-center space-y-4 max-w-md">
            <div className="text-6xl">🌱</div>
            <h1 className="text-2xl font-bold text-gray-800">Something went wrong</h1>
            <p className="text-gray-500 text-sm">
              An unexpected error occurred. Reloading the app usually fixes it.
            </p>
            <button
              onClick={this.handleReload}
              className="clay-button px-6 py-3 rounded-2xl font-semibold"
            >
              Reload EarthTrackr
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
